import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "@/lib/LanguageContext";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Services = () => {
  const { t, lang } = useLanguage();
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/services`)
      .then((res) => setServices(Array.isArray(res.data) ? res.data : []))
      .catch((e) => {
        console.error("Failed to load services:", e);
        setServices([]);
      });
  }, []);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="section-y bg-slate-50 relative"
    >
      <div className="container-x">
        <div className="max-w-2xl mb-14">
          <div className="overline mb-4">{t.services.overline}</div>
          <h2
            data-testid="services-title"
            className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4"
          >
            {t.services.title}
          </h2>
          <p className="text-slate-600 leading-relaxed">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Stethoscope;
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`service-card-${s.id}`}
                className="group bg-white p-6 rounded-2xl border border-slate-100 hover:border-blue-200 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-900/5 transition-all duration-300"
              >
                <div className="h-12 w-12 rounded-xl bg-blue-100 text-blue-800 flex items-center justify-center mb-5 group-hover:bg-blue-800 group-hover:text-white transition-colors">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">
                  {lang === "id" ? s.title_id : s.title_en}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {lang === "id" ? s.description_id : s.description_en}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
